enum RoutingRuleItemRoutingOption {
    AllItems = 'AllItems',
    OnlySelected = 'OnlySelected',
}

export default RoutingRuleItemRoutingOption;
